module.exports = __webpack_public_path__ + "static/media/edit-pen.f70cdb6d.svg";